var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "beer-collect-wrapper" },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { "left-arrow": "" },
            on: { "click-left": _vm.closeWeb },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow02.png"),
                        alt: "back",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content-wrapper" },
        [
          _c("MyPLabel", {
            staticClass: "title-wrapper",
            attrs: {
              str: _vm.$t("lang.beer.title"),
              customClass: { beer: "beeract-title-beer" },
            },
          }),
          _c(
            "div",
            { staticClass: "goods-wrapper" },
            [
              _c("div", { staticClass: "mine-wrapper" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("lang.beer.left")) + "：")]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/beer.png"),
                    alt: "icon",
                    width: "18",
                    height: "18",
                  },
                }),
                _c("span", [_vm._v(" " + _vm._s(_vm.beerRemainAmount))]),
              ]),
              _c("MyPLabel", {
                staticClass: "tips-wrapper",
                attrs: {
                  str: _vm.$t("lang.beer.tips"),
                  customClass: { beer: "beeract-tips-beer" },
                },
              }),
              _c(
                "div",
                { staticClass: "goods-list" },
                [
                  _vm.goodsLoading
                    ? _c(
                        "div",
                        { staticClass: "goods-loading-wrapper" },
                        [_c("van-loading")],
                        1
                      )
                    : _vm._l(_vm.goodsList, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.propType,
                            staticClass: "goods-item-wrap",
                            on: {
                              click: function ($event) {
                                return _vm.handleOpenPopup(item)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "goods-item" }, [
                              item.propType == 0 && _vm.ifExchangeCoinToday
                                ? _c("div", { staticClass: "shadow-mark" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("lang.beer.comeTomorrow")
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "item-title" },
                                [
                                  item.propType == 0
                                    ? [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("lang.beer.onceDaily")
                                            )
                                          ),
                                        ]),
                                      ]
                                    : [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("lang.beer.unlimited")
                                            )
                                          ),
                                        ]),
                                      ],
                                ],
                                2
                              ),
                              _c(
                                "div",
                                { staticClass: "item-image" },
                                [
                                  _c("PropsImg", {
                                    attrs: {
                                      propType: item.propType,
                                      width: "50",
                                      height: "50",
                                    },
                                  }),
                                  _c("div", { staticClass: "item-number" }, [
                                    _vm._v("x" + _vm._s(item.rewardAmount)),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  class: [
                                    "item-footer",
                                    _vm.beerRemainAmount < item.costBeerAmount
                                      ? "item-footer-off"
                                      : "",
                                  ],
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("lang.beer.redeem")) + " ("
                                    ),
                                  ]),
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/packageAssets/common/beer.png"),
                                      alt: "icon",
                                      width: "18",
                                      height: "18",
                                    },
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      "x" + _vm._s(item.costBeerAmount) + ")"
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                ],
                2
              ),
            ],
            1
          ),
          _c("div", { staticClass: "history-wrapper" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                _c("MyPLabel", {
                  attrs: {
                    str: _vm.$t("lang.beer.historyTitle"),
                    customClass: { beer: "beeract-histit-beer" },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "history-list-wrapper" },
              [
                _c(
                  "van-list",
                  {
                    staticClass: "list-wrapper",
                    attrs: {
                      offset: "100",
                      finished: _vm.historyFinished,
                      "loading-text": " ",
                      "finished-text":
                        _vm.historyList.length > 5
                          ? _vm.$t("lang.noMore")
                          : " ",
                    },
                    on: { load: _vm.handleGetHistoryMore },
                    model: {
                      value: _vm.historyloading,
                      callback: function ($$v) {
                        _vm.historyloading = $$v
                      },
                      expression: "historyloading",
                    },
                  },
                  _vm._l(_vm.historyList, function (item) {
                    return _c(
                      "div",
                      { key: item.propType, staticClass: "history-item" },
                      [
                        _c(
                          "div",
                          { staticClass: "item-left" },
                          [
                            _c("PropsImg", {
                              attrs: {
                                propType: item.propType,
                                width: "36",
                                height: "36",
                              },
                            }),
                            _c("span", { staticClass: "item-title" }, [
                              _vm._v(
                                _vm._s(_vm.getPropsName(item.propType) || "") +
                                  _vm._s(
                                    item.rewardAmount > 1 && item.propType !== 0
                                      ? `*${item.rewardAmount}`
                                      : ""
                                  )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "item-right" }, [
                          _c("div", { staticClass: "item-info" }, [
                            _c("span", [
                              _vm._v(_vm._s(item.costBeerAmount) + " "),
                            ]),
                            _c("img", {
                              attrs: {
                                src: require("@/assets/packageAssets/common/beer.png"),
                                alt: "icon",
                                width: "18",
                                height: "18",
                              },
                            }),
                          ]),
                          _c("span", { staticClass: "item-time" }, [
                            _vm._v(_vm._s(item.exchangeTime || "-")),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "van-dialog",
        {
          attrs: {
            title: "",
            className: "beer-van-dia",
            showConfirmButton: false,
            showCancelButton: false,
          },
          model: {
            value: _vm.popupVisible,
            callback: function ($$v) {
              _vm.popupVisible = $$v
            },
            expression: "popupVisible",
          },
        },
        [
          _c("div", { staticClass: "dialog-wrapper" }, [
            _c("div", { staticClass: "title-wrapper" }, [
              _vm._v(_vm._s(_vm.$t("lang.beer.confirmRedemption"))),
            ]),
            _c("div", { staticClass: "content-wrapper" }, [
              _c(
                "div",
                { staticClass: "image-wrapper" },
                [
                  _c("PropsImg", {
                    attrs: {
                      propType: _vm.currentItem.propType,
                      width: "40",
                      height: "40",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "text-wrapper" }, [
                _vm._v(
                  _vm._s(_vm.getPropsName(_vm.currentItem.propType) || "") +
                    " x " +
                    _vm._s(_vm.submitNumber)
                ),
              ]),
              _c(
                "div",
                { staticClass: "number-wrapper" },
                [
                  _c("van-stepper", {
                    attrs: {
                      step: "1",
                      min: "1",
                      "button-size": "40px",
                      max: _vm.maxNumber,
                      integer: "",
                      "disable-input": "",
                      disabled: _vm.currentItem.propType === 0,
                    },
                    model: {
                      value: _vm.submitNumber,
                      callback: function ($$v) {
                        _vm.submitNumber = $$v
                      },
                      expression: "submitNumber",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "footer-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "button-wrapper confirm",
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v(" " + _vm._s(_vm.$t("lang.confirm")) + " ")]
              ),
              _c(
                "div",
                {
                  staticClass: "button-wrapper cancel",
                  on: { click: _vm.handleClosePopup },
                },
                [_vm._v(" " + _vm._s(_vm.$t("lang.cfm.cancelBtn")) + " ")]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }